import { useVersion } from 'mir-utils/api-tools';
import { useGetApiV3Whoami } from 'mir-utils/api/whoami';
import { FC, useEffect } from 'react';
import { useTranslation } from 'mir-utils/i18n';
import { matchPath, useLocation } from 'react-router-dom';
import { pages } from './pages';

export const TitlePage: FC = () => {
  const { pathname } = useLocation();
  const version = useVersion();
  const [whoami] = useGetApiV3Whoami();
  const { t } = useTranslation();

  const getTitle = (): string | null => {
    if (version === undefined) {
      return t('Personal area');
    }
    if (matchPath(pathname, '/login/password-recovery')) {
      return t('Password recovery');
    }
    if (matchPath(pathname, '/login/sign-up')) {
      return t('Sign up Page');
    }
    if (matchPath(pathname, '/login')) {
      return t('Login Page');
    }

    const module = pages.find(
      ({ url, isPageHidden }) =>
        matchPath(pathname, url) &&
        whoami !== undefined &&
        (isPageHidden === undefined || !isPageHidden({ version, whoami }))
    );
    if (module !== undefined) {
      return module.title();
    }
    return null;
  };

  const title = getTitle();

  useEffect(() => {
    if (title !== null) {
      document.title = title;
    }
  }, [title]);
  return null;
};
